import type { SendTemplate } from 'services/types/message';

import type { Parameters } from './types';

/**
 * Turn the per-section parameter values into the `components` payload that the send/schedule
 * template APIs expect. Returns `undefined` when the template has no parameters.
 */
export default function buildTemplateComponents(parameters: Parameters): SendTemplate['components'] {
  const components: NonNullable<SendTemplate['components']> = [];
  (Object.keys(parameters) as (keyof Parameters)[]).forEach((key) => {
    if (parameters[key].length > 0) {
      components.push({
        type: key.toLowerCase() as 'header' | 'body' | 'footer' | 'button',
        parameters: parameters[key],
        sub_type: key === 'BUTTON' ? ('url' as const) : undefined,
        index: key === 'BUTTON' ? 0 : undefined,
      });
    }
  });
  return components.length === 0 ? undefined : components;
}
